export const getAssetLibraryFilterBarReadonlyStyle = (_, { palette = {} }) => ({
  filterBarReadonlyContainer: {
    display: 'flex',
    alignItems: 'center',

    '& .btn.btn-link': {
      marginLeft: '5px',
      color: palette.themePrimary,
      textDecoration: 'underline',
    },

    '& .filter-list': {
      height: 56,
      paddingLeft: 12,
      display: 'block',
      alignItems: 'center',
      textOverflow: 'ellipsis',
      color: palette.themePrimary,
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      fontFamily: 'Segoe UI',
      fontSize: '14px',
      lineHeight: '19px',
    },
    '& .filter-list:focus-within': {
      textOverflow: 'inherit', // collpase text would invisiable issues when use tab to change focus, reference here: https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_workitems/edit/3702640/
    },
  },
});

export const getViewAllFiltersButtonStyle = (component, { palette = {} }) => ({
  viewAllFilterItem: {
    '&.btn.btn-link': {
      display: 'block !important',
      height: 'auto',
      color: palette.themePrimary,
    },
  },
  viewAllPopoverCloseButton: {
    '&.btn': {
      position: 'absolute !important',
      border: 'none',
      minWidth: 'auto',
      padding: '3px',
      top: 9,
      right: 8,
    },
  },
  viewAllPopoverClassName: {
    maxWidth: 'initial !important',
    '& .popover-title': {
      display: 'flex',
      justifyContent: 'space-between',
      paddingRight: '5px',
      fontWeight: '600',
    },
  },
});

export const getAssetLibraryFilterBarEditingStyle = (_, { palette = {} }) => ({
  filterBarEditingContainer: {
    position: 'relative',
    minHeight: '56px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: palette.neutralLighter,

    '& .filter-list-editing': {
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      paddingLeft: 12,

      '& .filter-list-divider': {
        paddingRight: 12,
      },
    },

    '& .filter-bar-button-group': {
      marginLeft: 'auto',
      display: 'flex',
    },

    '& button.add-filter-button .iconba-Add': {
      color: palette.neutralSecondary,
    },
    '& button.filter-bar-button': {
      border: 'none',
      background: 'transparent',
      padding: '0px 7px',
      height: 56,
      '& .iconba': {
        color: palette.neutralSecondary,
      },
      '&:hover': {
        backgroundColor: palette.neutralLight,
      },
      '&:focus': {
        backgroundColor: palette.neutralQuaternaryAlt,
        '&:hover': {
          backgroundColor: palette.neutralQuaternary,
        },
      },
    },
    '& .filter-bar-divider': {
      borderLeft: `1px solid ${palette.neutralLight}`,
      margin: '8px 0px',
    },
    '& button.filter-bar-cancel-button': {
      padding: '0px 18px',
      minWidth: 'auto',
      '& .iconba:before': {
        color: palette.neutralSecondary,
      },
    },
  },
});
